import { Reveal, SectionHead } from "../components/Reveal";
import { COMPARISON } from "../data/content";

export const Differential = () => (
    <section id="diferencial" data-testid="differential-section" className="bg-cream py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="min-w-0 lg:col-span-5">
                    <SectionHead
                        eyebrow="O diferencial CAJUSP"
                        title="Especialização técnica, discrição e atendimento personalizado"
                    />
                    <Reveal delay={0.12} className="mt-8 space-y-6 text-base leading-relaxed text-graphite-text">
                        <p>
                            A CAJUSP se diferencia pela combinação de especialização técnica,
                            confidencialidade, independência e atendimento personalizado na
                            administração de procedimentos de arbitragem e mediação.
                        </p>
                        <p>
                            Mais do que administrar conflitos, a CAJUSP busca proporcionar um
                            ambiente institucional de confiança para a proteção de relações
                            empresariais, contratos, investimentos e patrimônio — com soluções
                            adequadas às necessidades de cada caso.
                        </p>
                    </Reveal>
                </div>

                <div className="min-w-0 lg:col-span-7">
                    <Reveal delay={0.15}>
                        {/* Mobile: cartões empilhados */}
                        <div className="overflow-hidden rounded-sm border border-cream-line bg-white md:hidden">
                            {COMPARISON.map((row, i) => (
                                <div
                                    key={row.aspect}
                                    data-testid={`comparison-card-${i}`}
                                    className="border-b border-cream-line p-6 last:border-b-0"
                                >
                                    <p className="font-serif text-xl text-ink">{row.aspect}</p>
                                    <div className="mt-4 space-y-4">
                                        <div>
                                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-graphite-text">
                                                Via judicial
                                            </p>
                                            <p className="mt-1.5 text-sm leading-relaxed text-graphite-text">
                                                {row.court}
                                            </p>
                                        </div>
                                        <div className="border-l-2 border-gold bg-gold/[0.06] px-4 py-3">
                                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-dark">
                                                Arbitragem CAJUSP
                                            </p>
                                            <p className="mt-1.5 text-sm leading-relaxed text-ink">
                                                {row.arb}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Desktop: tabela */}
                        <div className="hidden overflow-x-auto rounded-sm border border-cream-line bg-white md:block">
                            <table className="w-full min-w-[560px] border-collapse text-left">
                                <thead>
                                    <tr className="border-b border-cream-line">
                                        <th className="px-6 py-5 font-mono text-[10px] font-medium uppercase tracking-[0.24em] text-graphite-text">
                                            Aspecto
                                        </th>
                                        <th className="px-6 py-5 font-mono text-[10px] font-medium uppercase tracking-[0.24em] text-graphite-text">
                                            Via judicial
                                        </th>
                                        <th className="border-l border-gold/40 bg-gold/[0.06] px-6 py-5 font-mono text-[10px] font-medium uppercase tracking-[0.24em] text-gold-dark">
                                            Arbitragem CAJUSP
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {COMPARISON.map((row) => (
                                        <tr
                                            key={row.aspect}
                                            className="border-b border-cream-line last:border-b-0"
                                        >
                                            <td className="px-6 py-5 font-serif text-lg text-ink">
                                                {row.aspect}
                                            </td>
                                            <td className="px-6 py-5 text-sm leading-relaxed text-graphite-text">
                                                {row.court}
                                            </td>
                                            <td className="border-l border-gold/40 bg-gold/[0.06] px-6 py-5 text-sm leading-relaxed text-ink">
                                                {row.arb}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Reveal>
                    <Reveal delay={0.22}>
                        <p className="mt-5 text-xs leading-relaxed text-graphite-text">
                            Comparativo meramente ilustrativo de características gerais dos
                            procedimentos. A confidencialidade na arbitragem é estabelecida conforme
                            a legislação aplicável, os regulamentos institucionais e os compromissos
                            assumidos pelas partes.
                        </p>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
